var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 30.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 247 c-10 -28 1 -200 14 -205 9 -3 12 23 12 107 0 70 -4 111 -10 111 -6 0 -13 -6 -16 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 247 c-2 -7 -3 -56 -2 -108 l3 -94 80 0 80 0 0 105 0 105 -78 3 c-58 2 -79 -1 -83 -11z m136 -84 c0 -19 -47 -46 -62 -37 -5 3 -16 0 -24 -7 -22 -18 -30 -2 -9 21 11 13 25 18 37 14 12 -3 18 0 18 10 0 9 9 16 20 16 12 0 20 -7 20 -17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.5ab839f75c9e705e4ced3930ddb32495.svg";
export { ForwardRef as ReactComponent };